const KEY_STEP: Record<string, 1 | -1> = {
  ArrowRight: 1,
  ArrowUp: 1,
  ArrowLeft: -1,
  ArrowDown: -1,
};

/** A plot with a selection is a tab stop on web, a slider whose arrow keys
 *  move the same selection a tap moves (RNW forwards `focusable` and
 *  `onKeyDown` on a View; RNW drops the native adjustable actions). */
export function plotKeyboardProps(step: (d: 1 | -1) => void): object {
  return {
    focusable: true,
    onKeyDown: (e: { key: string; preventDefault: () => void }) => {
      const d = KEY_STEP[e.key];
      if (d === undefined) return;
      e.preventDefault();
      step(d);
    },
  };
}
